import { Box, CircularProgress } from '@mui/material';
import { ReactElement } from 'react';

export interface ILoadingProvider {
  isLoading: boolean;
  children: ReactElement;
}

export const LoadingProvider = (props: ILoadingProvider) => {
  if (props.isLoading) {
    return (
      <Box
        width="100%"
        height="100%"
        display="flex"
        justifyContent="center"
        alignItems="center">
        <CircularProgress />
      </Box>
    );
  }

  return props.children;
};
